if (window.location.href.indexOf('?error=access_denied') >= 0) {
  window.location.href = window.location.href.split('?')[0]
}
